// Pure functions, no Angular DI — cache-key derivation for offline mode (school + user +
// role + resource, per docs/offline-mode-plan.md §8). Deliberately not services: nothing
// here needs injection, and CLAUDE.md §13 says don't wrap what doesn't need wrapping.

// Same hostname-splitting convention UtilService.getNewSubdomainUrl already uses — not a
// new "which school" mechanism (CLAUDE.md R7 is about the backend's JWT-claim-vs-Referer
// conflict; the frontend already has exactly this one convention, reused verbatim here).
export function getCurrentSchoolSubdomain(): string | null {
  const parts = window.location.hostname.split('.');
  return parts.length >= 2 ? parts[0] : null;
}

// Local, unverified decode of the same token JwtInterceptorService already attaches to
// every request. Never used to gate authorization — only to namespace a local cache key.
// The API remains the real authorization boundary (plan §11 Ship Gate). Never throws.
export function decodeJwtPayload(token: string): Record<string, unknown> | null {
  try {
    const payloadSegment = token.split('.')[1];
    if (!payloadSegment) return null;
    const base64 = payloadSegment.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    return JSON.parse(atob(padded));
  } catch {
    return null;
  }
}

export function getCurrentUserId(token: string | null): number | null {
  if (!token) return null;
  const claims = decodeJwtPayload(token);
  const id = claims?.['id'];
  return typeof id === 'number' ? id : typeof id === 'string' && id !== '' ? Number(id) : null;
}

export function buildContentKey(school: string, user: number, kind: string, resourceId: string, version: string): string {
  return `${school}:${user}:${kind}:${resourceId}:${version}`;
}

export function buildIndexKey(school: string, user: number, kind: string, resourceId: string): string {
  return `${school}:${user}:${kind}:${resourceId}`;
}
